import Head from "next/head";
import { make as UnitsInfoPage } from "../../../../src/info/UnitsInfoPage.bs";

export default function UnitsInfo() {
  return (
    <>
      <Head>
        <title>Units Set 7.5 TFT Info & Best Item Builds</title>
      </Head>
      <UnitsInfoPage set={76} />
    </>
  );
}
